import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './lib/auth.jsx';
import { ThemeProvider } from './lib/theme.jsx';
import { ThemeDuCompte } from './components/ThemeDuCompte.jsx';
import { RequireAuth } from './components/RequireAuth.jsx';
import { RequireAdmin } from './components/RequireAdmin.jsx';
import { Landing } from './pages/Landing.jsx';
import { Auth } from './pages/Auth.jsx';
import { MotDePasseOublie } from './pages/MotDePasseOublie.jsx';
import { Reinitialiser } from './pages/Reinitialiser.jsx';
import { Bienvenue } from './pages/Bienvenue.jsx';
import { Dashboard } from './pages/Dashboard.jsx';
import { Preferences } from './pages/Preferences.jsx';
import { TripCreate } from './pages/TripCreate.jsx';
import { TripView } from './pages/TripView.jsx';
import { Admin } from './pages/Admin.jsx';
import { SharedTrip } from './pages/SharedTrip.jsx';
import { NotFound } from './pages/NotFound.jsx';

export function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <ThemeDuCompte />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/connexion" element={<Auth mode="login" />} />
          <Route path="/inscription" element={<Auth mode="register" />} />
          <Route path="/mot-de-passe-oublie" element={<MotDePasseOublie />} />
          <Route path="/reinitialiser/:token" element={<Reinitialiser />} />

          {/* Sous RequireAuth comme les autres : le garde qui y mène s'abstient
              de rediriger quand on y est déjà, ce qui évite la boucle. */}
          <Route
            path="/bienvenue"
            element={(
              <RequireAuth>
                <Bienvenue />
              </RequireAuth>
            )}
          />
          <Route
            path="/voyages"
            element={(
              <RequireAuth>
                <Dashboard />
              </RequireAuth>
            )}
          />
          <Route
            path="/preferences"
            element={(
              <RequireAuth>
                <Preferences />
              </RequireAuth>
            )}
          />
          <Route
            path="/voyages/nouveau"
            element={(
              <RequireAuth>
                <TripCreate />
              </RequireAuth>
            )}
          />
          <Route
            path="/voyages/:id"
            element={(
              <RequireAuth>
                <TripView />
              </RequireAuth>
            )}
          />

          <Route
            path="/admin"
            element={(
              <RequireAdmin>
                <Admin />
              </RequireAdmin>
            )}
          />

          {/* Page publique : consultable sans compte. */}
          <Route path="/share/:token" element={<SharedTrip />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </ThemeProvider>
    </AuthProvider>
  );
}
